import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-[linear-gradient(180deg,rgba(22,18,34,0.8),rgba(26,22,40,0.9))] py-12 md:py-20 px-4 md:px-5 text-center border-t border-b border-[rgba(184,174,206,0.1)] fu" data-id="element-240">
      <div className="w-16 h-16 md:w-[80px] md:h-[80px] bg-[linear-gradient(135deg,rgba(232,150,12,0.15),rgba(255,107,53,0.1))] border-2 border-[rgba(232,150,12,0.5)] rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 text-[26px] md:text-[32px] shadow-[0_0_30px_rgba(232,150,12,0.1)]" data-id="element-241">
        🛡️
      </div>
      <h3 className="font-serif text-[clamp(2.2rem,6vw,3.4rem)] text-[var(--gold-l)] italic mb-3 md:mb-4" data-id="element-242">
        Garantía incondicional de 7 días.
      </h3>
      <div className="div-line" data-id="element-243"></div>
      <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] max-w-[540px] mx-auto leading-[1.9] mt-4 md:mt-5 font-400" data-id="element-244">
        Si sentís que el material no es lo que esperabas, te devolvemos el{' '}
        <strong className="text-[#F0EAF8] font-700" data-id="element-245">100% de tu dinero</strong>.
        <strong className="text-[#F0EAF8] font-700" data-id="element-246"> Sin preguntas</strong>, sin
        vueltas. Queremos que tu decisión sea completamente{' '}
        <span className="text-[#E8C88A] font-700" data-id="element-247">libre de riesgo</span>.
      </p>
    </section>;
}